import { type FlexProps as ChakraFlexProps } from '@chakra-ui/react';
import { Flex as ChakraFlex } from '@chakra-ui/react';
import React from 'react';

export type FlexProps = ChakraFlexProps;

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  return <ChakraFlex ref={ref} {...props} />;
});

Flex.displayName = 'Flex';
